<template>
  <div class="mb-3">
    <span class="mr-1" v-html="name"></span>
    <base-button v-if="btnTitle" class="reduced-padding-btn" :backgroundColor="createdHabitId ? green : ''" :borderColor="createdHabitId ? green : ''" @click="showHabit">{{btnTitle}}</base-button>
  </div>
</template>

<script>
import BaseButton from '@/components/base/buttons/BaseButton'
import { GREEN_COLOUR } from '@/constants/colours'
import clinicHistoryMixin from '@/mixins/clinicHistory.mixin'

export default {
    components: {
        BaseButton
    },
    data () {
        return {
            green: GREEN_COLOUR
        }
    },
    props: {
        id: Number,
        name: String,
        frequencyId: Number,
        unit: String,
        createdHabitId: String
    },
    mixins: [clinicHistoryMixin],
    methods: {
        showHabit () {
            if (!this.createdHabitId && this.historyReadOnly) return
            let route = this.$helpers.getHabitsUrl(`${this.createdHabitId ? `show/${this.createdHabitId}` : `createByType/${this.id}/${this.name}/${this.frequencyId}/${this.unit}`}${this.$route.query.patientId ? `/${this.$route.query.patientId}` : ''}`)
            window.open(route, '_blank').focus()
        }
    },
    computed: {
        btnTitle () {
            return this.createdHabitId ? this.$t('watch') : !this.historyReadOnly ? this.$t('create') : null
        }
    }
}
</script>

<style lang="scss" scoped>
</style>


// WEBPACK FOOTER //
// src/components/shared/HistoryHealthyHabitsItem.vue